/**
 * 안전 홈페이지(사용자 지시 2026-10-27 · `safe/` 앱) — 그룹웨어의 「안전 관리」 메뉴를 떼어 낸 곳.
 *
 * <p>메뉴는 지웠지만 <b>옛 주소는 살아 있어야 한다.</b> 할일 링크(`TodoItemResponse` 의 SAFETY_SIGN →
 * `/safety/education?open=`)는 모바일 앱도 같은 글자로 받아 자기 화면을 열기 때문에 서버 쪽 주소를 바꾸지
 * 않았고, 이미 인쇄해 붙인 이수확인서 QR 은 `/safety-sign/{token}` 을 가리킨다. 둘 다 라우터가 이 주소로 넘긴다.
 *
 * <p>권한 키 `safety` 는 그대로다 — 권한 매트릭스의 「안전 관리」 한 줄이 안전 홈페이지 전체를 연다.
 */
export const SAFETY_HOME_URL: string =
  import.meta.env.VITE_SAFETY_URL ?? (import.meta.env.DEV ? 'http://localhost:5175' : 'https://safe.bomienc.com');

/** 그룹웨어의 옛 주소 → 안전 홈페이지 주소. `/safety` → `/` · `/safety/patrol` → `/patrol` · `/safety-sign/x` → `/sign/x`. */
export function toSafetyHome(pathname: string, search: string): string {
  const path = pathname.startsWith('/safety-sign/')
    ? `/sign/${pathname.slice('/safety-sign/'.length)}`
    : pathname.replace(/^\/safety\/?/, '/');
  return `${SAFETY_HOME_URL}${path}${search}`;
}
